module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-counterclockwise-8a95f473.svg";